// extracted by mini-css-extract-plugin
module.exports = {"frame":"SinglePage_frame__z1Lu4","content":"SinglePage_content__1zNq5","screen-box":"SinglePage_screen-box__2aBQ8"};